(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neem-delivered-price"] && !Shopify.designMode) return;
  try {
    (() => {
  const mount = () => {
    const panel = document.getElementById('neem-delivered-price');
    if (!panel || panel.dataset.bound) return;
    panel.dataset.bound = 'true';
    const money = value => {
      const text = value?.textContent?.trim() || '';
      const match = /^(?:Rs\.?|₹)\s*([\d,]+(?:\.\d{1,2})?)$/.exec(text);
      if (!match) return null;
      const amount = Number(match[1].replace(/,/g, ''));
      return Number.isFinite(amount) && amount >= 0 ? Math.round(amount * 100) : null;
    };
    const format = value => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value / 100);
    const setText = (selector, value) => {
      const target = panel.querySelector(selector);
      if (target.textContent !== value) target.textContent = value;
    };
    const read = () => {
      const info = panel.closest('.wt-product__info');
      const button = info?.querySelector('.es-popup-button-product');
      const embedded = info?.querySelector('#easysell-embedded-offers');
      const selected = embedded?.querySelector('.es-qo-container[offer-selected="true"]');
      const forms = [...document.querySelectorAll('#es-form')];
      if (!button || !selected || forms.length !== 1 || button.getAttribute('aria-disabled') === 'true') return null;
      const form = forms[0];
      const formSelected = form.querySelector('.es-qo-container[offer-selected="true"]');
      const pack = selected.querySelector('.offer-title')?.textContent.trim();
      const count = /^Buy ([123])$/.exec(pack || '');
      if (!count || pack !== formSelected?.querySelector('.offer-title')?.textContent.trim()) return null;
      const image = selected.querySelector('img')?.getAttribute('src');
      if (!image || image !== formSelected.querySelector('img')?.getAttribute('src')) return null;
      const offer = money(selected.querySelector('.es-o-p'));
      if (offer === null || offer !== money(formSelected.querySelector('.es-o-p'))) return null;
      const subtotal = money(form.querySelector('.es-subt-line .label-value'));
      if (subtotal !== Number(panel.dataset.unitPrice) * Number(count[1])) return null;
      const prepaidButton = form.querySelector('#es-checkout_16');
      const codButton = form.querySelector('#es-form-button');
      const allowed = el => el && !el.disabled && !el.hidden && getComputedStyle(el).display !== 'none';
      if (!allowed(prepaidButton) || !allowed(codButton)) return null;
      const prepaid = money(prepaidButton.querySelector('.es-total-placeholder'));
      const cod = money(codButton.querySelector('.es-total-placeholder'));
      const shipping = money(form.querySelector('.es-shipping-line .label-value'));
      const fee = money(form.querySelector('.es-fee-line .label-value'));
      const shippingRadio = form.querySelector('.shipping-label input:checked');
      const shippingName = shippingRadio?.closest('.shipping-label')?.querySelector('.shipping-name')?.textContent.trim();
      if ([prepaid, cod, shipping, fee].some(v => v === null) || !shippingName) return null;
      if (prepaid <= 0 || prepaid > subtotal + shipping || cod - prepaid !== fee) return null;
      const error = [...form.querySelectorAll('[role="alert"], .invalid-feedback')].some(el => el.textContent.trim() && getComputedStyle(el).display !== 'none');
      if (error) return null;
      return { button, pack, prepaid, cod, shipping, fee, shippingName };
    };
    const update = () => {
      if (!panel.isConnected) { observer.disconnect(); return; }
      const quote = read();
      if (!quote) { panel.hidden = true; return; }
      if (panel.nextElementSibling !== quote.button) quote.button.before(panel);
      setText('[data-neem-pack]', quote.pack + ' · ' + panel.dataset.pack);
      setText('[data-neem-prepaid]', format(quote.prepaid));
      setText('[data-neem-cod]', format(quote.cod));
      setText('[data-neem-charges]', quote.shippingName + ': ' + format(quote.shipping) + '. ' + panel.dataset.cod + ': ' + format(quote.fee) + '.');
      panel.hidden = false;
    };
    let timer;
    const queue = () => { clearTimeout(timer); panel.hidden = true; timer = setTimeout(update, 100); };
    const observer = new MutationObserver(records => {
      if (records.some(record => {
        if (panel.contains(record.target)) return false;
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return target?.closest('#es-form, #easysell-embedded-offers, .es-popup-button-product') || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('#es-form, #easysell-embedded-offers') || node.querySelector('#es-form, #easysell-embedded-offers')));
      })) queue();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['offer-selected', 'disabled', 'aria-disabled', 'hidden', 'style', 'class', 'src'] });
    document.addEventListener('change', event => { if (event.target.closest('#es-form, #easysell-embedded-offers')) queue(); });
    document.addEventListener('click', event => { if (event.target.closest('#es-form, #easysell-embedded-offers')) queue(); });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
  } catch(e) { console.error(e); }
})();

})();
